<div class="reset-page screen-bottom-halo">
  <div class="logo-container">
    <img class="logo-icon" src="assets/images/explain-logo-900.svg" alt="explain_logo" />
    <img class="logo-text" src="assets/images/explain-text-900.svg" alt="explain_text" />
  </div>

  <div class="reset-card">
    <div class="success-content">
      <!-- Animated success icon -->
      <div class="success-icon-wrapper">
        <svg
          class="success-check"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>

      <!-- Text -->
      <div class="card-header">
        <h2 class="card-title">{{ 'reset-password.success-screen-title' | translate }}</h2>
        <p class="card-subtitle">{{ 'reset-password.success-screen-subtitle' | translate }}</p>
        <p class="card-subtitle">{{ 'reset-password.success-screen-redirect' | translate }}</p>
      </div>

      <!-- CTA Button -->
      <button type="button" class="btn-submit btn-forgot-cta" (click)="goToLogin()" data-cy="reset-password-success-back-link">
        {{ 'reset-password.success-screen-cta' | translate }}
      </button>

      <!-- Countdown -->
      <p class="countdown-text">
        {{ 'reset-password.success-screen-countdown' | translate: { count: countdown() } }}
      </p>
    </div>
  </div>
</div>
